

<template>
  <div :class="['title-container']">
    <div :class="['title']">
      <h3>{{ preheader }}</h3>
      <h1>{{ title }}</h1>
      <div class="title-bottom" v-if="subtitle == null">
        <div class="label">
          {{ labelLeft }}
        </div>
        <div class="shape">
          <Shape :shape="shape"></Shape>
        </div>
        <div class="label">
          {{ labelRight }}
        </div>
      </div>
      <div class="subtitle" v-else-if="subtitle != null">
        {{ subtitle }}
      </div>
      <div class="subtitleDate" v-if="subtitleDate != null">
        {{ subtitleDate }}
      </div>
    </div>
  </div>
</template>

<script>
import Shape from "@/components/Shape.vue";

export default {
  name: "Title",
  components: {
    Shape,
  },
  data() {
    return {};
  },
  props: {
    title: {
      default: "Title",
    },
    preheader: {
      default: "Campus Complex",
    },
    labelLeft: {
      default: "Autumn Archives",
    },
    labelRight: {
      default: "Posted Jan 2023",
    },
    shape: {
      default: "hexagon",
    },
    subtitle: {
      default: null,
    },
    subtitleDate: {
      default: null,
    },
  },
  computed: {
    shapeSvg() {
      switch (this.shape) {
        case "hexagon":
          return "<p>hex</p>";
        default:
          return "";
      }
    },
  },
  methods: {},
  mounted() {},
};
</script>

<style>
.title-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 18rem;
  margin-bottom: 12rem;
  width: 100%;
}

.title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/* .title .subtitle {

} */

.title h3 {
  font-family: "Scala";
  font-style: italic;
  font-weight: bold;
  font-size: 2rem;
  line-height: 130%;
  text-align: center;
  filter: blur(0.1rem);
  margin-bottom: 0;
}

.title h1 {
  margin: 0;
  margin-bottom: 0;
  margin-top: 6px;
  font-family: "Sabon";
  font-style: normal;
  /* font-weight: 400; */
  font-size: 6rem;
  line-height: 150%;
  text-align: center;

  -webkit-text-stroke: 1.5px var(--black);
  filter: blur(0.3rem);
}

.title .label {
  font-family: "Andale";
  font-style: normal;
  font-weight: normal;
  font-size: 1.8rem;
  line-height: 150%;
  /* text-align: right; */

  filter: blur(0.1rem);
}

.title-bottom {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  grid-gap: 1.2rem;
}

.title-bottom .shape {
  margin-top: 0.2rem;
  width: 5rem;
}

.title .subtitle {
  font-size: 2.8rem;
  line-height: 150%;
  filter: blur(0.1rem);
  padding: 0 4rem;
  max-width: 78rem;
  text-align: center;
  margin-top: 1px;
  margin-bottom: 1rem;
}

.title .subtitleDate {
  font-size: 1.8rem;
  line-height: 150%;
  filter: blur(0.1rem);
  color: var(--orange);
  font-weight: bold;
  font-family: "Andale", monospace;
  -webkit-text-stroke: 0.05rem var(--orange);
}

@media (max-width: 655px) {
  .title h1 {
    -webkit-text-stroke: 1px var(--black);
  }
}

@media (max-width: 380px) {
  .title h1 {
    font-size: 4.75rem;
    filter: blur(0.2rem);
  }
}

@supports (-webkit-touch-callout: none) {
  /* CSS specific to iOS devices */
  .title h1 {
    letter-spacing: -1px;
  }
}
</style>
